


























































































import Vue from 'vue';
import { WorkflowJobTabModel, WorkflowJobTabType, TabStateModel, WorkflowStandardProcessingAction, WorkflowElementIdConstants } from '@/types';
import WorkflowDynamicForm from '@/components/workflow/WorkflowDynamicForm.vue';
import WorkflowJobHistoryTab from '@/components/workflow/standardtabs/WorkflowJobHistoryTab.vue';
import WorkflowJobAuditTab from '@/components/workflow/standardtabs/WorkflowJobAuditTab.vue';
import MStoreDocumentInformationTab from '@/components/shared/Tabs/MStoreDocumentInformationTab.vue';
import { WorkflowFormValidation, workflowTabsHelper } from '@/mixins';
import MStoreNarrativeTab from '@/components/shared/Tabs/MStoreNarrativeTab.vue';
import MStoreVersionsTab from '@/components/shared/Tabs/MStoreVersionsTab.vue';
import MStoreRelatedDocumentsTab from '@/components/shared/Tabs/MStoreRelatedDocumentsTab.vue';
import WorkflowFullTextTab from '@/components/workflow/standardtabs/WorkflowFullTextTab.vue';
import WorkflowJobTracingTab from '@/components/workflow/standardtabs/WorkflowJobTracingTab.vue';
import { mapGetters, mapActions } from 'vuex';
import ResizeObserver from 'resize-observer-polyfill';

export default Vue.extend({
  name: 'HorizontalWorkflowJobTabs',
  mixins: [WorkflowFormValidation, workflowTabsHelper],
  props: {
    processingAction: {
      type: Number,
      validator: (processingAction: number) => WorkflowStandardProcessingAction[processingAction] !== undefined,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isWorkflowJobLocked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadedTabs: [] as WorkflowJobTabModel[],
      tabBottomPosition: 0,
      borderSize: 1,
      resizeObserver: {} as ResizeObserver,
      jobTabOrientation: 'horizontal',
      useAltAxis: false,
      workflowJobDocumentViewerContainerHeight: 0
    };
  },
  methods: {
    ...mapActions('workflowJobStore', ['setActiveHorizontalTab', 'setJobTabStateCount', 'setJobTabStateDirty']),
    ...mapActions('userPreferencesStore', ['setIsHorizontalTabUp']),
    updateItemCount(this: any, result: TabStateModel) {
      this.setJobTabStateCount(result);
    },
    updateIsDirty(this: any, result: TabStateModel) {
      this.setJobTabStateDirty(result);
    },
    loadedTabKey(this: any, loadedTab: WorkflowJobTabModel): string {
      return loadedTab.componentName === 'DocumentInformationTab' ? this.documentSearchModel.documentId : loadedTab.key;
    },
    onHorizontalTabClick(this: any, tabKey: string) {
      this.setHorizontalTabUpUserPreference();
      this.setActiveHorizontalTab(tabKey);
      this.$nextTick(() => {
        this.useAltAxis = this.$refs.horizontalTabs?.offsetHeight > 300;
      });
    },
    onHorizontalTabExpandButtonClick(this: any) {
      const tabKey = this.activeHorizontalTab?.key ? this.activeHorizontalTab.key : this.visibleHorizontalJobTabs[0]?.key;
      this.onHorizontalTabClick(tabKey);
    },
    setHorizontalTabUpUserPreference(this: any) {
      this.setIsHorizontalTabUp({
        isHorizontalTabUp: this.activeHorizontalTab?.key ? false : true,
        queueId: this.workflowJob.queueId
      });
    },
    getWorkflowJobDocumentViewerContainerHeight(this: any) {
      const element = document.getElementById(WorkflowElementIdConstants.WorkflowDocumentViewerContainerId);
      this.workflowJobDocumentViewerContainerHeight = element?.clientHeight;
    },
    onWorkflowJobDocumentViewerContainerResize(this: any, tab: HTMLElement) {
      this.$nextTick(() => {
        this.getWorkflowJobDocumentViewerContainerHeight();
      });
    }
  },
  watch: {
    activeHorizontalTab(this: any, activeTab: WorkflowJobTabModel) {
      if (this.activeTabIsStandardTabWithoutPreload && !this.loadedTabs.includes(activeTab)) {
        this.loadedTabs.push(activeTab);
      }
    }
  },
  computed: {
    ...mapGetters('workflowJobStore', [
      'workflowJob',
      'horizontalJobTabs',
      'visibleHorizontalJobTabs',
      'visibleHorizontalWorkflowJobTabs',
      'workflowDataSources',
      'activeHorizontalTab',
      'jobTabState',
      'workflowDocumentIsPlaceholder'
    ]),
    ...mapGetters('documentViewStore', ['documentSearchModel']),
    ...mapGetters('userPreferencesStore', ['getWorkflowJobPreferences']),
    preloadTabs(this: any): WorkflowJobTabModel[] {
      return this.visibleHorizontalJobTabs.filter((x: WorkflowJobTabModel) => x.workflowJobTabType !== WorkflowJobTabType.Workflow && x.preLoad);
    },
    activeTabIsStandardTabWithoutPreload(this: any): boolean {
      return this.activeHorizontalTab.workflowJobTabType === WorkflowJobTabType.Standard && !this.activeHorizontalTab.preLoad;
    },
    activeTabIsStandardTabAndHasAlreadyBeenLoaded(this: any): boolean {
      return this.loadedTabs.includes(this.activeHorizontalTab) && this.activeHorizontalTab.workflowJobTabType === WorkflowJobTabType.Standard;
    },
    isCancelProcess(this: any): boolean {
      return this.processingAction === WorkflowStandardProcessingAction.CancelJob;
    },
    horizontalTabExpandButtonIcon(this: any): string {
      return this.activeHorizontalTab?.key ? 'angle-double-down' : 'angle-double-up';
    },
    slideUpStyle(this: any) {
      if (!this.workflowDocumentIsPlaceholder) {
        return '';
      }
      const slideUpHeight = this.workflowJobDocumentViewerContainerHeight ? this.workflowJobDocumentViewerContainerHeight - 200 : 400;
      return `max-height: ${slideUpHeight}px; min-height: ${slideUpHeight}px;`;
    }
  },
  mounted(this: any) {
    if (this.getWorkflowJobPreferences(this.workflowJob.queueId).isHorizontalTabUp || this.workflowDocumentIsPlaceholder) {
      this.onHorizontalTabExpandButtonClick(this);
    }

    const viewerContainer = document.getElementById(WorkflowElementIdConstants.WorkflowDocumentViewerContainerId) as HTMLElement;
    this.viewerResizeObserver = new ResizeObserver(() => this.onWorkflowJobDocumentViewerContainerResize(viewerContainer));
    this.viewerResizeObserver.observe(viewerContainer);
  },
  beforeDestroy(this: any) {
    this.viewerResizeObserver.disconnect();
  },
  components: {
    WorkflowDynamicForm,
    WorkflowJobHistoryTab,
    WorkflowJobAuditTab,
    MStoreDocumentInformationTab,
    MStoreNarrativeTab,
    MStoreVersionsTab,
    MStoreRelatedDocumentsTab,
    WorkflowFullTextTab,
    WorkflowJobTracingTab
  }
});
